// extracted by mini-css-extract-plugin
module.exports = {"image":"SocialMediaPack_image__14zd7","imagesWrapper":"SocialMediaPack_imagesWrapper__3FmA6","imageWrapper":"SocialMediaPack_imageWrapper__2cyUw"};